import { useLocation, useParams } from 'react-router-dom';
import { Marca } from '../componentes/Marca.tsx';
import { BotaoLink, Cartao, Dado, Etiqueta, Icone } from '../componentes/ui/index.ts';
import { moeda } from '../lib/api.ts';

/**
 * Confirmação clara com nome e protocolo. Junto do botão desabilitado no
 * envio, é o que de fato evita a duplicata acidental — o responsável que não
 * lembra se enviou tem onde conferir.
 */
export function Confirmacao() {
  const { protocolo = '' } = useParams();
  const estado = useLocation().state as { nomeAdolescente?: string; valorTotal?: string } | null;
  const valor = estado?.valorTotal && Number(estado.valorTotal) > 0 ? estado.valorTotal : null;

  return (
    <div className="container container-form" style={{ paddingBlock: 'var(--gap-6)' }}>
      <header style={{ marginBottom: 'var(--gap-7)' }}>
        <Marca />
      </header>

      <main id="conteudo" className="pilha-5">
        <div className="chapa">
          <Etiqueta>
            <Icone.Check tamanho={13} /> Recebida
          </Etiqueta>
          <h1 style={{ marginTop: 'var(--gap-4)', color: 'inherit' }}>
            Inscrição
            <br />
            confirmada
          </h1>
        </div>

        <Cartao>
          <div className="pilha">
            {estado?.nomeAdolescente && (
              <p style={{ fontSize: 'var(--texto-lg)' }}>
                A inscrição de <strong>{estado.nomeAdolescente}</strong> foi recebida.
              </p>
            )}

            {/* Protocolo como comprovante carimbado: bloco de tinta, rótulo em
                pixel e o número alinhado à esquerda, não centralizado. */}
            <div
              style={{
                background: 'var(--superficie-alta)',
                border: 'var(--fio) solid var(--borda-forte)',
                padding: 'var(--gap-4)',
              }}
            >
              <span className="dymo">Protocolo</span>
              <div
                className="numeral destaque"
                style={{ marginBlock: 'var(--gap-3) var(--gap-2)', letterSpacing: '0.01em' }}
              >
                {protocolo}
              </div>
              <div className="codigo-barras texto-fraco" aria-hidden="true" />
            </div>

            {valor && <Dado titulo="Valor do acampamento">{moeda(valor)}</Dado>}

            <p className="editorial texto-suave" style={{ fontSize: 'var(--texto-lg)' }}>
              Guarde este número — é por ele que a liderança localiza a inscrição. Enviamos uma
              confirmação por e-mail com as orientações de pagamento.
            </p>
          </div>
        </Cartao>

        <BotaoLink para="/" variante="vazado" largo>
          Inscrever outro adolescente
        </BotaoLink>
      </main>
    </div>
  );
}
